<script setup lang="ts">
import { ref, watch } from 'vue'

import { classMerge } from '../utils'
import { useCarouselDots } from './use-carousel-dots'

const { onDotButtonClick, selectedIndex, scrollSnaps } = useCarouselDots()

const visibleDots = 5
const startIndex = ref(0)

watch(selectedIndex, (newIndex) => {
  if (newIndex === 0) {
    startIndex.value = 0
  } else if (newIndex === scrollSnaps.value.length - 1) {
    startIndex.value = Math.max(0, scrollSnaps.value.length - visibleDots)
  } else if (newIndex >= startIndex.value + 3) {
    startIndex.value = Math.min(newIndex - 3, scrollSnaps.value.length - visibleDots)
  } else if (newIndex <= startIndex.value + 1) {
    startIndex.value = Math.max(newIndex - 1, 0)
  }
})
</script>

<template>
  <div class="relative mx-auto my-4 w-16 h-2.5">
    <span
      v-for="(_, index) in scrollSnaps"
      :key="index"
      :class="classMerge('w-2.5 h-2.5 border rounded-full shrink-0 absolute transition-all duration-300 ease-in-out border-action-ghost-foreground', {
        'bg-action-ghost-foreground': index === selectedIndex,
        'bg-transparent': index !== selectedIndex,
        'opacity-100': index >= startIndex && index < startIndex + visibleDots,
        'opacity-0': index < startIndex || index >= startIndex + visibleDots,
      })"
      :style="{
        transform: `translateX(${(index - startIndex) * 13.5}px)`,
      }"
      @click="onDotButtonClick(index)" />
  </div>
</template>
